import { FC } from "react";
import NoDataSVG from "./nodata";
import "./styles.css";

interface NoDataFoundProps {
  text?: string;
}

const NoDataFound: FC<NoDataFoundProps> = ({ text }) => {
  return (
    <div>
      <NoDataSVG dynamicText={text} />
    </div>
  );
};

export default NoDataFound;
